import { AddEventSuccess, SuccessFooter } from './AddEventSuccess';
import { AddEventWizard, WizardFooter, WizardHeader } from './AddEventWizard'
import { ModalTypes } from '../../actions/types'

export const MODAL_TYPES = {
  [ModalTypes.ADD_EVENT_WIZARD]: {
    pages: [
      {
        body: AddEventWizard, 
        footer: WizardFooter,
        header: WizardHeader
      },
      {
        body: AddEventSuccess,
        footer: SuccessFooter,
        header: 'div',
      }
    ]
  }
};



/** WEBPACK FOOTER **
 ** ./components/modal/ModalTypes.js
 **/